export default __webpack_public_path__ + "static/media/10.cc40d99c.JPG";